import { Component, OnDestroy } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { DATEPICKER_LOCALE } from 'shared/calendar.sv';
import { AuthenticationService } from 'core/authentication.service';

@Component({
  selector: 'ecom-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent implements OnDestroy {
  constructor(
    private config: PrimeNG,
    private auth: AuthenticationService
  ) {
    this.config.setTranslation(DATEPICKER_LOCALE);
  }

  ngOnDestroy(): void {
    this.auth.ngOnDestroy();
  }
}
